import { createFileRoute } from "@tanstack/react-router";
import { filterParam, optionParam, textParam } from "@/utils/searchParams";
import type { UserRole } from "@/hooks/types";

// The directory's filters live in the URL, so leaving the page and coming back
// keeps the slice of people the admin had narrowed to (NAV-45).
//
// The whole role vocabulary, one entry each.
export const FILTERABLE_ROLES = [
  "SUPER_ADMIN",
  "BU_ADMIN",
  "GROUP_LEGAL",
  "END_USER",
] as const satisfies readonly UserRole[];

export type AdminUsersSearch = {
  q?: string;
  // Free text, not a fixed list: the options are the active business units, so
  // a BU that has since been archived filters to nothing.
  bu?: string;
  role?: (typeof FILTERABLE_ROLES)[number];
};

export const Route = createFileRoute("/admin/users")({
  validateSearch: (search: Record<string, unknown>): AdminUsersSearch => ({
    q: textParam(search.q),
    bu: filterParam(search.bu),
    role: optionParam(FILTERABLE_ROLES, search.role),
  }),
});
